import { toByteArray } from "base64-js";

export type CaPubKey = {
    id: number;
    pub: Uint8Array;
};

// These are the CA Ed25519 public keys used to sign and verify MCU public keys.
// See https://github.com/Salient-Motion/CA?tab=readme-ov-file#keys
export const CA_PUBKEYS_FOR_MCU_CERTS: CaPubKey[] = [
    {
        id: 0x101, // decimal 257
        pub: toByteArray( "DAxmneQJLB3CqRlTLC2YJLmTzk4TspPG1wEoRAtfJCw=" ),
    },
    {
        id: 0x102, // decimal 258
        pub: toByteArray( "Y+TpFWNLmV/UDfqnbNF1/wPhjLEx8eRIFWrqdpnFmJA=" ),
    },
];
